// extracted by mini-css-extract-plugin
module.exports = {"wrap":"uc","contentWrapCtaDefault":"vc","disabled":"wc","contentWrapCtaWhite":"xc","promos":"yc","lazyPromo":"zc","mainContent":"Ac","headingText":"Bc","copy":"Cc","subtext":"Dc"};